import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '../services/permission/permission.service';
import { firstValueFrom, map } from 'rxjs';
import { ProfileService } from 'src/app/services/profile/profile.service';

@Injectable({
	providedIn: 'root',
})
export class PermissionGuardService {
	private readonly ProfileService = inject(ProfileService);
	private readonly PermissionService = inject(PermissionService);
	private readonly Router = inject(Router);

	async canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
		if (!route.data || !route.data.roles) {
			alert('** Essa rota solicitou o permission guard mas não tem roles definidas!');
			this.Router.navigate(['/404']);
			return false;
		}

		if (route.data.analystOnly === true && localStorage.getItem('sessionStatus') === '0') {
			this.Router.navigate(['/404']);
			return false;
		}

		const user = await firstValueFrom(this.ProfileService.setLocalUser());
		return firstValueFrom(this.PermissionService.initPermissions().pipe(map(() => this.checkPermission(route.data.roles))));
	}

	checkPermission(permissionRoles: string[]): boolean {
		for (const role of permissionRoles) {
			if (!this.PermissionService.hasPermission(role)) {
				this.Router.navigate(['/404']);
				return false;
			}
		}

		return true;
	}
}
